import portalApi from '../../../../lvya-common/src/api/eos/portal'

// 获取栏目列表
export async function useGetCategories(pId) {
  let reqData = { pId, pageSize: 999, pageNum: 1, isContent: 'Y', ishide: 'N' }
  let resData = await portalApi.getTypeListByPage(reqData)
  console.log({ resData })
  return resData
}
